import {MainViewContainer} from '../../common/MainViewContainer/MainViewContainer';
import {Deductions} from './Deductions';

export const FormulaView = () => {
  return (
    <MainViewContainer title="Deduction Formulas">
      <Deductions type="formula" />
    </MainViewContainer>
  );
};
